// extracted by mini-css-extract-plugin
export var standaloneTable = "_g5-0";
export var standaloneTableWithBodyFill = "_g5-1";
export var withExtraHeader = "_g5-2";